/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import * as lc from '../../../../../utils/lodashCustom';
import * as dateFormatter from '../../../../../utils/formatter';
import { restructureUserModel } from '../../../../users/services/UserService/restructuring';

export function restructureRoomModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    userId: lc.get(data, 'user_id'),
    privateUserId: lc.get(data, 'private_user_id'),
    roomId: lc.get(data, 'room_id'),
    roomUuid: lc.get(data, 'room_uuid'),
    roomType: lc.get(data, 'room_type'),
    roomName: lc.get(data, 'room_name'),
    roomNamePrivate: lc.get(data, 'room_name_private'),
    roomOwnerId: lc.get(data, 'room_owner_id'),
    shortDescUser: lc.get(data, 'short_desc_user'),
    picture: lc.get(data, 'picture'),
    countNew: lc.get(data, 'count_new'),
    authorLastMessage: lc.get(data, 'author_last_message'),
    authorLastMessageAvatarPath: lc.get(data, 'authorLastMessageAvatarPath'),
    authorLastMessageUsername: lc.get(data, 'authorLastMessageUsername'),
    shortLastMessage: lc.get(data, 'short_last_message'),
    creatorId: lc.get(data, 'creator_id'),
    createdAt: lc.get(data, 'created_at'),
    createdAtFormatted: dateFormatter.dateFormat1(lc.get(data, 'created_at')),
    updatedAt: lc.get(data, 'updated_at'),
    members: _.get(data, 'members')
      ? data.members.map(item => restructureUserModel(state, item))
      : null,
    viewedMembers: _.get(data, 'viewedMembers')
      ? data.viewedMembers.map(item => ({
          id: lc.get(item, 'id'),
          username: lc.get(item, 'username'),
          concatRoles: lc.get(item, 'concat_roles')
        }))
      : null
  };
}

export function restructureMessageModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    image: lc.get(data, 'image'),
    messageContent: lc.get(data, 'message_content'),
    senderId: lc.get(data, 'sender_id'),
    username: lc.get(data, 'username'),
    roomId: lc.get(data, 'room_id'),
    createdAt: lc.get(data, 'created_at'),
    createdAtFormatted: dateFormatter.dateFormat1(lc.get(data, 'created_at')),
    updatedAt: lc.get(data, 'updated_at'),
    messageMeta: lc.get(data, 'messageMeta'),
    userRoom: _.get(data, 'userRoom')
      ? restructureRoomModel(state, _.get(data, 'userRoom'))
      : null
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/services/MessengerService/restructuring/index.js